import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";
import { entityOfType } from "../../../utils/system-entities";
import { SystemEntity } from "@erp/shared-types";

/**
 * Extract AP Invoice from Document Step
 *
 * Uses AI to extract structured invoice data from a single document.
 * This step is designed for fanout scenarios where multiple invoice
 * documents are processed in parallel child workflows.
 *
 * The handler calls APInvoiceExtractionService with a specific document
 * rather than processing an entire email.
 *
 * Note: This is a backend-only step that requires database access.
 * The handler is registered in backend/src/workflows/steps/handlers/
 */
export const extractAPInvoiceFromDocumentStep = defineStepConfig({
  type: "extract_ap_invoice_from_document",
  name: "Extract AP Invoice from Document",
  description:
    "Extract structured invoice data from a single document using AI",
  category: "Data Access",

  inputSchema: z.object({
    document: entityOfType(SystemEntity.CORE_DOCUMENT).describe(
      "The document to extract invoice data from",
    ),
  }),

  outputSchema: z.object({
    extractionResultId: z.uuid(),
  }),

  configSchema: z.object({
    // Future: add config for extraction models, confidence thresholds
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "5 minutes",
    retry: {
      maximumAttempts: 2,
      initialInterval: "10 seconds",
      backoffCoefficient: 2,
    },
  },
});
